import { CurrencyType } from "@soposopo/sopo-models";

export class SopoToastSettings {
    enterAnimation?: EnterAnimation;
    autoDismissAnimation?: DismissAnimation;
    animationSpeed?: AnimationTiming;
    toastIcon?: ToastIcon;
	doNotCloseOnClear?: boolean;
    data?: IToastData;
    header?: string;
    message?: string;
    dismissAfter?: number;
    cssClasses?: string | string[];
    zIndex?: number;
}

export const DEFAULT_SOPO_TOAST_SETTINGS: SopoToastSettings = {
    enterAnimation: 'slide-in-from-right',
    autoDismissAnimation: 'slide-out-to-right',
    animationSpeed: 'normal',
    toastIcon: 'prediction',
	doNotCloseOnClear: false,
    data: {},
    header: '',
    message: '',
    dismissAfter: 0,
    cssClasses: '',
    zIndex: 0,
}

export type ToastIcon = 'ring-point' | 'prediction' | 'network';

export type EnterAnimation = 'fade-in' | 'zoom-in' | 'slide-in-from-left' | 'slide-in-from-right';

export type DismissAnimation = 'fade-out' | 'zoom-out' | 'slide-out-to-left' | 'slide-out-to-right';

export type AnimationTiming = 'normal' | 'fast' | 'slow';

export const DEFAULT_SOPO_TOAST_DISMISS_TIME = 5000;

export interface IPredictWonToastData {
    amountWon: number;
    currency: CurrencyType.GOLD | CurrencyType.SWEEPBUCK;
}

export interface IToastButtonData {
    text: string;
    handler: () => void;
}

export interface IToastData {
    predictWon?: IPredictWonToastData
    button?: IToastButtonData,
}
